import React, { useEffect, useMemo, useState } from 'react'
import { enqueueSnackbar } from 'notistack';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Spinner } from 'react-bootstrap';
import { getData } from '../services/commonServices';
import moment from 'moment'
import ImageWithFallback from './ImageWithFallback';

function ViewPatientDetail() {
    const navigate = useNavigate();
    const [detailsPatients, setDetailsPatients] = useState({});
    const [showLoaderPatients, setShowLoaderPatients] = useState(true);
    const { search } = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const typeParam = params.get('type');
    const idParam = params.get('id');
    useEffect(() => {
        const fetchDetails = async () => {
            if (!typeParam || !idParam) {
                setShowLoaderPatients(false);
                return;
            }
            let data = await getData({ "parent": typeParam, id: idParam });
            if (data.status === 200) {
                setDetailsPatients({ ...data.data.data[0] });
                setShowLoaderPatients(false);
            }
            else {
                enqueueSnackbar("Error while getting patient details",
                    { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                setShowLoaderPatients(false);
            }
        }
        fetchDetails();
    }, [typeParam, idParam]);

    const handleClick = () => {
        let url = '/' + typeParam + 's'
        if (typeParam === 'dialysisCenters') {
            url = '/dialysis-centers'
        }
        else if (typeParam === 'physicianGroup') {
            url = '/physician-groups'
        }
        navigate(url)
    }
    return (
        <Container fluid>
            {!showLoaderPatients &&
                (Object.keys(detailsPatients).length > 0 ?
                    <Card className="mb-2" bg="light">
                        <Card.Header>
                            <Row>
                                <Col xs={8}>
                                    <h4 className="header-text" style={{ marginLeft: 15 }}>{detailsPatients.name}</h4>
                                </Col>
                                <Col xs={4} className="text-end">
                                    <Button className="btn btn-success" onClick={handleClick}>
                                        Back
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Header>
                        <Card.Body>
                            <Container fluid>
                                <Card bg="white" className="mb-3 p-3">
                                    <Row className="mb-3">
                                        <Col xs={4}>
                                            <div style={{ display: "flex", flexDirection: "column", borderRadius: "8px", border: "none!important", height: "80%", width: "80%", alignItems: "center" }}>
                                                <ImageWithFallback
                                                  src={detailsPatients?.profileImage}
                                                  alt="img"
                                                  style={{ height: "250px", width: "250px", borderRadius: "8px", border: "none!important", objectFit: "contain" }}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={8}>
                                            <Row className="mb-3">
                                                <Col xs={6}>
                                                    <h6>Application Id</h6>
                                                    <span>{detailsPatients?.applicantId || "N/A"}</span>
                                                </Col>
                                                <Col xs={6}>
                                                    <h6>Phone</h6>
                                                    <span>{detailsPatients?.phoneNumber|| "N/A"}</span>
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col xs={6}>
                                                    <h6>Email</h6>
                                                    <p>{detailsPatients?.email || "N/A"}</p>
                                                </Col>
                                                <Col xs={6}>
                                                    <h6>Registration Date</h6>
                                                    <p>{moment(detailsPatients.createdAt).format("LL")}</p>
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col xs={6}>
                                                    <h6>Type</h6>
                                                    <p>{detailsPatients?.userType || `N/A`}</p>
                                                </Col>
                                                <Col xs={6}>
                                                    <h6>Status</h6>
                                                    <p>{detailsPatients?.status || `N/A`}</p>
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <h6>Address</h6>
                                                <p>{detailsPatients?.address || "N/A"}</p>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            </Container>
                        </Card.Body>
                    </Card> : <div style={{ marginLeft: "40%", marginTop: "100px" }}><h3>No Data Available</h3></div>)}
            {showLoaderPatients && <Spinner animation="border" style={{ marginLeft: "50%", marginTop: "5%", width: "4rem", height: "4rem" }} size='lg' />}
        </Container>
    )
}

export default ViewPatientDetail